import classNames from 'classnames';
import { Link } from 'react-router-dom';
import styles from './NEW_IwLink.module.css';
import { navigateTo } from './HistoryProvider';
import { maintainStateKey } from './LocationHelper';

export const NEW_IwLinkButton = ({
    className,
    to,
    children,
    onClick,
    disabled = false,
    variant = 'primary',
    'data-testid': dataTestId
}: {
    className?: string;
    to: {
        pathname?: string;
        search?: string;
        hash?: string;
    };
    onClick?: (event: React.MouseEvent) => void;
    disabled?: boolean;
    children: React.ReactNode;
    variant?: 'primary' | 'secondary' | 'tertiary';
    'data-testid'?: string;
}) => {
    const handleClick = (event: React.MouseEvent) => {
        event.preventDefault();
        if (disabled) return;
        if (onClick) onClick(event);

        navigateTo(maintainStateKey(to));
    };

    const variantClassName =
        variant === 'primary'
            ? styles.primary
            : variant === 'secondary'
              ? styles.secondary
              : styles.tertiary;

    return (
        <Link
            to={maintainStateKey(to)}
            className={classNames([
                styles.link,
                styles.linkButton,
                variantClassName,
                className
            ])}
            onClick={handleClick}
            onAuxClick={(event) => event.preventDefault()} // prevents middle mouse click opening link in new tab without running the onClick
            data-testid={dataTestId}
        >
            {children}
        </Link>
    );
};
